// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 7.5C6 4.46243 8.46243 2 11.5 2C14.5376 2 17 4.46243 17 7.5C17 10.5376 14.5376 13 11.5 13C8.46243 13 6 10.5376 6 7.5ZM18 14C17.3096 14 16.75 14.5596 16.75 15.25V16H22.4985V22.5H13.4985V16H14.75V15.25C14.75 13.4551 16.2051 12 18 12C18.8936 12 19.7045 12.3619 20.291 12.9448L21.0003 13.6498L19.5904 15.0683L18.8811 14.3634C18.6541 14.1377 18.3441 14 18 14ZM11.5 22H2V20C2 16.6863 4.68629 14 8 14H11.5V22Z"}}]};

const UserUnlockedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-unlocked-filled',
    ref,
    icon: element,
  },
));

UserUnlockedFilledIcon.displayName = 'UserUnlockedFilledIcon';

export default UserUnlockedFilledIcon;
